import ReactDOM from 'react-dom';
import React from 'react';
import PreviewAndPopupPlayerContainer from './PreviewAndPopupPlayerContainer';
export {PreviewAndPopupPlayerContainer};
import PopupPlayerLink from './PopupPlayerLink';
export {default as FixedAspectRatioPlayer} from './FixedAspectRatioPlayer';

/**
 * Expose a render function to global scope so mustache template can access it.
 *
 * @param domElement
 * @param props
 */
window.renderVimeoPopupPlayerInElement = function (domElement, props) {
    ReactDOM.render(
        <PreviewAndPopupPlayerContainer {...props}/>,
        domElement
    );
};

/**
 *
 * @param domElement
 * @param {String} text
 * @param {id,width,height} video
 * @param {string} downloadUrl
 */
window.renderVimeoLinkToPopupVideo = function (domElement, text, video, downloadUrl) {
    ReactDOM.render(
        <PopupPlayerLink text={text} video={video} downloadUrl={downloadUrl}/>,
        domElement
    );
};

export {default as PlayerIFrame} from './PlayerIFrame';
export {default as DownloadVideo} from './DownloadVideo';
